<script setup lang="ts">
import { RouterView } from "vue-router";
import Navigation from "@/components/general/Navigation.vue";
import AuthFence from "@/components/general/AuthFence.vue";
import { onMounted, ref } from "vue";
import Container from "@/lib/Container";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const domain = import.meta.env.VITE_GOOGLE_HD as string;
const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string;
const title = ref("Vint: Demokratie & Transparenz");
const auth = ref<{ name: string } | undefined>(undefined);

async function useCredential(cred: string) {
	const authManager = await Container.authManager();
	await authManager.useCredential(cred);
	const payload = authManager.payload();
	auth.value = { name: payload.name };
}

async function clearAuth() {
	const authManager = await Container.authManager();
	authManager.clear();
	auth.value = undefined;
}

onMounted(() => {
	Container.authManager()
		.then(value => {
			if (value.isAuthenticated()) auth.value = { name: value.payload().name };
		});
});

</script>

<template>
	<navigation :title="title" :auth="auth" @clear-auth="clearAuth" />
	<auth-fence v-if="auth === undefined" :domain="domain" :client-id="clientId" @credential="useCredential" />
	<router-view v-if="auth !== undefined" />
	<footer class="footer mt-5">
		<div class="content has-text-centered">
			<p>
				<strong>Vint</strong> erstellt mit viel ❤️ und Hilfe durch andere Volter*innen
				von <a href="mailto:janpeter.koenig@volteuropa.org">Jan Peter König</a>.
			</p>
		</div>
	</footer>
</template>

<style scoped>
</style>
